
import { defineComponent, reactive, ref } from 'vue';
import ActiveList from '@/components/ActiveList.vue';
import { List, PullRefresh } from 'vant';
import { useRouter } from 'vue-router';
import { getMyCaseInfo } from '@/http/home';
import getList from '@/http/castList';

export default defineComponent({
  components: {
    ActiveList,
    [List.name]: List,
    [PullRefresh.name]: PullRefresh,
  },
  setup() {
    // console.log(this);
    const router = useRouter();
    const state = reactive({
      list: [],
      loading: false,
      finished: false,
      refreshing: false,
    });
    const myHouser = ref({});
    getMyCaseInfo().then((res: any) => {
      myHouser.value = res.result;
    });
    const onJump = (id: string) => {
      router.push({
        path: '/caseInfo',
        query: { projectid: id },
      });
    };
    const pages = reactive({
      pageNo: 0,
      pageSize: 6,
    });
    const onLoad = () => {
      console.log('11');
      state.loading = true;
      pages.pageNo += 1;
      state.finished = false;
      console.log('112');
      getList(pages).then((res: any) => {
        console.log(66);
        const { total } = res.result;
        const data: [] = res.result.records;
        state.refreshing = false;
        state.list.push(...data);
        state.loading = false;
        console.log(state.list.length);
        console.log(total);
        if (state.list.length === total) {
          state.finished = true;
        }
      });
    };
    const onRefresh = () => {
      state.list = [];
      pages.pageNo = 0;
      onLoad();
    };
    return {
      state,
      onLoad,
      onJump,
      myHouser,
      onRefresh,
    };
  },
});
